<template>
  <tg-dialog
    ref="dialog"
    :title="title"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :visible.sync="visible"
    :showIcon="false"
    :showFooter="true"
    :showCancelBtn="true"
    :confirmLabel="confirmLabel"
    :cancelLabel="cancelLabel"
    width="35%"
    @on-confirm="handleBulkOpen"
    @on-cancel="handleBulkClose"
    class="tg-member-privilege-bulk-dialog"
  >
    <el-row type="flex" justify="start" align="middle">
      <span>{{ $t("component.label.function") }}</span>
      <span class="mb-3">|</span>
      <span class="text-primary clickable" @click="toggleSelectAll">{{
        functional_label
      }}</span>
    </el-row>
    <el-row type="flex" justify="start" align="middle">
      <el-checkbox-group v-model="functional" @change="handleFunctionalChange">
        <template v-for="item in privileges">
          <el-checkbox
            :label="item.name"
            :key="item.name"
            :disabled="!item.enable_change"
            >{{ $t("column." + item.name + "_short") }}</el-checkbox
          >
        </template>
      </el-checkbox-group>
    </el-row>
    <!-- 階層選項 -- label -->
    <el-row type="flex" justify="start" align="middle">
      <span
        >{{ $t("component.label.level")
        }}<span class="text-info text-size-xx-small"
          >({{ $t("component.label.single_option") }})</span
        ></span
      >
    </el-row>
    <!-- 階層選項 -- username -->
    <el-row type="flex" justify="start" align="middle">
      <el-checkbox v-model="selectTarget" :disabled="functional.length == 0">{{
        targetName
      }}</el-checkbox>
    </el-row>
    <!-- 階層選項 -- level -->
    <el-row type="flex" justify="start" align="middle">
      <el-radio-group v-model="level" :disabled="functional.length == 0">
        <template v-for="lv in maxLevel">
          <el-radio :key="lv" :label="lv">{{
            $t("enum.level[" + (lv - 1) + "]")
          }}</el-radio>
        </template>
      </el-radio-group>
    </el-row>
    <!-- 登入選項 -- label -->
    <el-row type="flex" justify="start" align="middle">
      <span
        >{{ $t("component.label.login_limit")
        }}<span class="text-info text-size-xx-small"
          >({{ $t("component.label.single_option") }})</span
        ></span
      >
    </el-row>
    <!-- 登入選項 -- filter -->
    <el-row type="flex" justify="start" align="middle">
      <el-radio-group
        class="login-limit"
        v-model="filter"
        :disabled="functional.length == 0"
      >
        <template v-for="(filter, i) in filters">
          <template v-if="i >= selectedFilter">
            <el-radio :key="i" :class="{ mini: i == 0 }" :label="filter.value">
              <template v-if="i == 0">
                {{ $t("component.label.no_limit") }}
              </template>
              <template v-else>
                {{ filter.label }}
              </template>
            </el-radio>
          </template>
        </template>
      </el-radio-group>
    </el-row>
  </tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
  },
  data() {
    return {
      visible: false,
      selectAll: false,
      functional: [],
      selectTarget: false,
      level: null,
      filter: null,
    };
  },
  props: {
    columns: Array,
    // 登入的下拉
    filters: Array,
    selectedFilter: Number,
    target: Object,
    maxLevel: Number,
    selectedLevel: Number,
  },
  computed: {
    title() {
      return this.$t("component.btn.bulk_operation");
    },
    confirmLabel() {
      return this.$t("component.btn.bulk_open");
    },
    cancelLabel() {
      return this.$t("component.btn.bulk_close");
    },
    functional_label() {
      let n = this.selectAll ? 0 : 1;
      return this.$t("enum.select_all[" + n + "]");
    },
    privileges() {
      let privileges = JSON.parse(JSON.stringify(this.columns));

      return privileges.slice(1, -1);
    },
    targetName() {
      if (!this.target) {
        return "";
      }

      return this.target.username + "(" + this.target.usernickname + ")";
    },
    request() {
      return {
        targetName: this.target.username,
        level: this.level,
        filter: this.filter,
        update_target: this.selectTarget,
        functional: this.functional,
      };
    },
  },
  created() {
    this.toggleFunctional(!this.selectAll);
    this.level = this.selectedLevel;
    this.filter = this.selectedFilter;
  },
  methods: {
    showDialog() {
      this.selectAll = false;
      this.functional = [];
      this.selectTarget = false;
      this.level = this.selectedLevel;
      this.filter = this.selectedFilter;
      this.visible = true;
    },
    toggleFunctional(selectAll) {
      // 相反操作
      this.functional = selectAll
        ? []
        : this.privileges.reduce((a, b) => {
            a.push(b.name);
            return a;
          }, []);
    },
    toggleSelectAll() {
      // 相反操作
      this.toggleFunctional(this.selectAll);
      this.selectAll = !this.selectAll;
    },
    handleFunctionalChange(items) {
      this.selectAll = this.privileges.length == items.length;
    },
    handleBulkOpen(e) {
      if (this.functional.length > 0) {
        this.$emit("bulk-open", this.request);
      } else {
        e.preventDefault = true;
      }
    },
    handleBulkClose(e) {
      if (this.functional.length > 0) {
        this.$emit("bulk-close", this.request);
      } else {
        e.preventDefault = true;
      }
    },
  },
  watch: {
    selectedLevel(val) {
      this.level = val;
    },
    selectedFilter(val) {
      this.filter = val;
    },
  },
};
</script>
